/** Labels and option lists for stock register (Phase 2). */

export const STOCK_UNIT_TYPES = [
  { value: 'each', label: 'Each' },
  { value: 'box', label: 'Box' },
  { value: 'drum', label: 'Drum' },
  { value: 'metre', label: 'Metre' },
  { value: 'roll', label: 'Roll' },
  { value: 'pack', label: 'Pack' },
  { value: 'length', label: 'Length' },
  { value: 'other', label: 'Other' },
];

export const STOCK_CATEGORIES = [
  { value: 'consumables', label: 'Consumables' },
  { value: 'fixings', label: 'Fixings' },
  { value: 'cable', label: 'Cable' },
  { value: 'tools', label: 'Tools' },
  { value: 'safety', label: 'Safety' },
  { value: 'other', label: 'Other' },
];

export const MOVEMENT_TYPES = [
  { value: 'purchase', label: 'Purchase' },
  { value: 'adjustment', label: 'Adjustment' },
  { value: 'job_use', label: 'Job use' },
  { value: 'return', label: 'Return' },
  { value: 'transfer', label: 'Transfer' },
  { value: 'count', label: 'Stock count' },
  { value: 'other', label: 'Other' },
];

export const labelFor = (options, value) =>
  options.find((o) => o.value === value)?.label ?? value ?? '—';

export const formatStockCurrency = (amount) => {
  if (amount == null || amount === '') return '—';
  return new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP' }).format(amount);
};

export const formatQuantity = (qty, unitType) => {
  if (qty == null) return '—';
  const n = parseFloat(qty);
  const unit = labelFor(STOCK_UNIT_TYPES, unitType);
  return `${n % 1 === 0 ? n : n.toFixed(2)} ${unit}`;
};
